export default __webpack_public_path__ + "static/media/homer-simpson-never-try.e460ae20.gif";